import {
  ImportContacts,
  PaywallDescriptor,
  SimpleTrial,
  UpgradeAi,
  UpgradeAiFromTrial,
} from 'common/billing/components/Paywall/interfaces'
import { ImportContactsPaywallProps } from 'common/billing/components/Paywall/variants/ImportContactsPaywall/types'
import { UpgradeModalVersion } from 'common/billing/constants'

export const paywalls = {
  simpleTrial: (props: SimpleTrial): PaywallDescriptor => ({
    variant: UpgradeModalVersion.SIMPLE_TRIAL,
    props,
  }),
  importContacts: (props: ImportContacts): PaywallDescriptor => ({
    variant: UpgradeModalVersion.IMPORT_CONTACTS,
    props,
  }),
  upgradeAi: (props: UpgradeAi): PaywallDescriptor => ({
    variant: UpgradeModalVersion.UPGRADE_AI,
    props,
  }),
  upgradeAiFromTrial: (props: UpgradeAiFromTrial): PaywallDescriptor => ({
    variant: UpgradeModalVersion.UPGRADE_AI_FROM_TRIAL,
    props,
  }),
  custom: (): PaywallDescriptor => ({
    variant: UpgradeModalVersion.CUSTOM,
  }),
  universal: (): PaywallDescriptor => ({
    variant: UpgradeModalVersion.UNIVERSAL_PAYWALL,
  }),
}

export type { PaywallDescriptor, ImportContactsPaywallProps }
